import React, { Component, PropTypes } from 'react';

import css from './cornerLabel.scss';

export default class CornerLabel extends Component {
	static propTypes = {
		name: PropTypes.string.isRequired,
	};

	render() {
		return (
			<header className='block-label--absolute'>{this.props.name}</header>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/block/cornerLabel.js
 **/